package com.ijoin.data.model

import kotlinx.serialization.Serializable

/**
 * Paginated response wrapper matching Spring Data Page structure
 */
@Serializable
data class PageResponse<T>(
    val content: List<T>,
    val totalElements: Long = 0,
    val totalPages: Int = 0,
    val size: Int = 20,
    val number: Int = 0,
    val numberOfElements: Int = 0,
    val first: Boolean = true,
    val last: Boolean = false,
    val empty: Boolean = false
)
